<p-toast></p-toast>

<p-message
  *ngIf="errorMessage"
  severity="error"
  [text]="errorMessage"
  class="mb-3"
></p-message>

<!-- precisa estar no template para o ConfirmationService funcionar -->
<p-confirmDialog></p-confirmDialog>

<!-- Cabeçalho com título e ações -->
<div class="card-header">
  <div class="title">
    <div class="card-title-row">
      <h2>{{ integrityName || 'Integridade' }}</h2>
      <p class="selection-hint" *ngIf="selectedRows.length">
        {{ selectedRows.length }} registro(s) selecionado(s) para resolução.
      </p>
    </div>
    <p class="copy-hint" *ngIf="!isStandalone">
      Clique no título da coluna para copiar a coluna ou dê um duplo clique na
      linha para copiar seus valores.
    </p>
  </div>

  <div class="card-actions-wrapper">
    <div class="actions">
      <button
        pButton
        type="button"
        icon="pi pi-play"
        [label]="resolveButtonLabel"
        class="p-button-rounded p-button-success"
        [disabled]="loading || executing || resolving"
        (click)="resolve()"
        pTooltip="Resolver problemas"
        [attr.aria-label]="resolveButtonLabel"
      ></button>
      <button
        *ngIf="!isStandalone"
        pButton
        type="button"
        icon="pi pi-refresh"
        class="p-button-rounded p-button-text p-button-icon-only p-button-sm p-button-info"
        [disabled]="loading || executing || resolving"
        (click)="refresh()"
        pTooltip="Atualizar"
        aria-label="Atualizar"
        [loading]="executing"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-pencil"
        class="p-button-rounded p-button-text p-button-icon-only p-button-sm p-button-secondary"
        [disabled]="loading || executing || resolving"
        (click)="openEdit()"
        pTooltip="Editar"
        aria-label="Editar"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-trash"
        class="p-button-rounded p-button-text p-button-icon-only p-button-sm p-button-danger"
        [disabled]="loading || executing || resolving"
        (click)="delete(integrityId, $event)"
        pTooltip="Excluir"
        aria-label="Excluir"
      ></button>
    </div>
  </div>
</div>

<!-- Mensagem standalone quando não há dados de query -->
<div *ngIf="!loading && isStandalone && rows.length === 0" class="standalone-info">
  <p-message
    severity="info"
    text="Este handler é autônomo e busca seus próprios dados internamente. Clique em Resolver para executar."
  ></p-message>
</div>

<!-- Tabela -->
<div class="table-view" *ngIf="!loading && (!isStandalone || rows.length > 0)">
  <p-table
    [value]="rows"
    [scrollable]="true"
    scrollHeight="flex"
    [(selection)]="selectedRows"
    [dataKey]="rowIdKey"
    selectionMode="multiple"
    [paginator]="true"
    [rows]="rowsPerPage"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [totalRecords]="totalRecords"
    (onPage)="onPage($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngFor="let col of columns">
          <button
            type="button"
            class="copy-header"
            pTooltip="Copiar coluna"
            tooltipPosition="top"
            (click)="copyColumn(col, $event)"
          >
            <span>{{ col }}</span>
            <i class="pi pi-copy" aria-hidden="true"></i>
          </button>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr class="data-row" (dblclick)="copyRow(row, $event)">
        <td>
          <p-tableCheckbox [value]="row"></p-tableCheckbox>
        </td>
        <td *ngFor="let col of columns">{{ row[col] }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Modal de edição embutido -->
<p-dialog
  header="Editar Integridade"
  [(visible)]="showEditDialog"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '900px', maxWidth: '95vw' }"
  (onHide)="onDialogHide()"
  [draggable]="false"
>
  <app-integrity-form
    *ngIf="showEditDialog"
    [integrityId]="integrityId"
    [embedded]="true"
    (saved)="onFormSaved()"
    (deleted)="onFormDeleted()"
  />
</p-dialog>